import { gql } from 'graphql-request';

export const submissionsQuery = gql`
  query Submissions($params: SubmissionQueryParams) {
    submissions(params: $params) {
      data {
        data {
          formDetails
          personalDetails {
            experienceBrief
            referredByModelAgency
            agencyName
            instaHandle
            tiktokHandle
          }
          personalAttributes {
            height
            chest
            waist
            hips
            eyeColor
          }
          portfolio {
            photos {
              photo {
                assetId
                assetType
                assetMetaData
                thumbnailUrl
              }
            }
            videos {
              video {
                status
                assetId
                assetType
                assetMetaData
                assets
              }
            }
          }
          openCallId
          stageId
        }
        profile {
          nationality
          firstName
          lastName
          pronouns
          contactEmail
          dob
          address {
            city
            country
          }
          status
        }
        rating {
          id
          rating
          status
          authorID
          createdAt
        }
        ratings {
          id
          rating
          status
          authorID
          createdAt
        }
        createdAt
        _id
        updatedAt
        averageRating
        amountOfRatings
      }
      count
      summary {
        isRepresented
        nationalities
        cities
        ages
        heights
        eyeColors
        hips
        chests
        waists
      }
      _ids
    }
  }
`;

export const bulkUpdateStageQuery = gql`
  mutation BulkChangeStage(
    $stageId: String!
    $userId: String!
    $candidateIds: [String!]!
  ) {
    bulkChangeStage(
      stageId: $stageId
      userId: $userId
      candidateIds: $candidateIds
    ) {
      count
    }
  }
`;

export const candidateExportToFileQuery = gql`
  query ContactExport($candidateIds: [String!]!) {
    contactExport(ids: $candidateIds) {
      candidateId
      averageScore
      stageId
      email
      firstName
      lastName
      pronouns
    }
  }
`;

export const exportFinalistsToCopilotQuery = gql`
  query ExportFinalistsToCopilot(
    $candidateIds: [String!]!
    $openCall: OpenCallInfoForCopilotExport!
  ) {
    exportFinalistsToCopilot(ids: $candidateIds, openCall: $openCall) {
      visualStoryURL
    }
  }
`;
